"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.STRING = exports.NUMBER = exports.ENUMERATION = exports.DATE_TIME = exports.DATE = exports.BOOLEAN = void 0;
var BOOLEAN = 'bool';
exports.BOOLEAN = BOOLEAN;
var DATE = 'date';
exports.DATE = DATE;
var DATE_TIME = 'datetime';
exports.DATE_TIME = DATE_TIME;
var ENUMERATION = 'enumeration';
exports.ENUMERATION = ENUMERATION;
var NUMBER = 'number';
exports.NUMBER = NUMBER;
var STRING = 'string';
exports.STRING = STRING;